import React from "react";
import { useIntl } from "react-intl";
import { Typography, Row, Col } from "antd";

const LoadErrorText = ({ message }) => {
  const intl = useIntl();
  return (
    <Row type="flex" justify="center" className="margin-bottom-2">
      <Col>
        <Typography.Text type="danger">
          {message ||
            intl.formatMessage({
              id: "messages.loadError",
              defaultMessage: "Při načítání dat nastala chyba",
            })}
        </Typography.Text>
      </Col>
    </Row>
  );
};

export default LoadErrorText;
